import React, { Component } from "react";
import { Platform } from "react-native";
import { VideoMedia } from "../../../models/Image";

export type VideoOverlayProps = {
	video: VideoMedia;
	videoId: string;
	autoPlay: boolean;
	format?: string;
	width?: string;
	height?: string;
}; // TODO: add video type

class VideoPlayer extends Component<VideoOverlayProps> {
	state = {
		modalVisible: false,
		// format: "video/mp4" // TODO: add validation
		// video/webm
	};

	componentWillUnmount() {}

	render() {
		if (!this.props.video) return null;

		return (
			<video
				key={this.props.video.url}
				// style={{ maxWidth: "100%" }}
				id={this.props.videoId}
				className="mss-video"
				controls
				width={this.props.width || "auto"}
				height={this.props.height || "auto"}
				// style={{ maxWidth: "100%", maxHeight: "100%" }}
				poster={this.props.video.thumbUrl}
				autoPlay={this.props.autoPlay && Platform.OS !== "android"}
			>
				<source src={this.props.video.url} type={this.props.video.vidFormat || "video/mp4"} />
				Sorry, your browser doesn't support embedded videos.
			</video>
		);
	}
}

export default VideoPlayer;
